import { getGraphqlClient } from "@/api/graphql/client.ts";
import { StartSupportSessionMutation } from "@/api/graphql/impersonate/startSupport/mutations";
import type { AccountsMsStartSupportRequest } from "@/api/graphql/types/graphql.ts";

export const startSupportSession = async (
  request: AccountsMsStartSupportRequest,
) => await getGraphqlClient().request(StartSupportSessionMutation, { request });
